import {
  AfterContentInit,
  Component,
  ElementRef,
  EventEmitter, Input,
  OnChanges,
  OnDestroy,
  Output, SimpleChanges,
  ViewChild
} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {from, Observable, Subscription} from "rxjs";
import {map, switchMap} from "rxjs/operators";
import * as BpmnJS from 'bpmn-js/dist/bpmn-viewer.production.min.js';

@Component({
  selector: 'app-diagram',
  template: `<div #ref class="diagram-container"></div>`,
  styles: [
    `
          .diagram-container {
            height: 100%;
            width: 100%;
          }
        `
  ]
})
export class DiagramComponent implements AfterContentInit, OnChanges, OnDestroy {
  private bpmnJS: BpmnJS;
  private overlays: any;
  private elementRegis: any;

  @ViewChild('ref', { static: true }) private el: ElementRef;
  @Output() private importDone: EventEmitter<any> = new EventEmitter();

  @Input() private url: string;
  @Input() private taskUrl: string;
  @Input() private myHeader: any;

  constructor(private http: HttpClient) {

    this.bpmnJS = new BpmnJS();

    this.bpmnJS.on('import.done', ({ error }) => {
      if (!error) {
        this.bpmnJS.get('canvas').zoom('fit-viewport');
        this.overlays = this.bpmnJS.get('overlays');
        this.elementRegis = this.bpmnJS.get('elementRegistry');
      }
    });
  }

  ngAfterContentInit(): void {
    this.bpmnJS.attachTo(this.el.nativeElement);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.url) {
      this.loadUrl(changes.url.currentValue);
    }
  }

  ngOnDestroy(): void {
    this.bpmnJS.destroy();
  }

  /**
   * Load diagram from URL and emit completion event
   */
  loadUrl(url: string): Subscription {

    return (
      this.http.get(url, {
        headers: this.myHeader,
        responseType: 'text'
      }).pipe(
        switchMap((xml: string) => this.importDiagram(xml)),
        map(result => result.warnings),
      ).subscribe(
        (warnings) => {
          if (this.taskUrl) {
            let shape = this.elementRegis.get(this.taskUrl);
            let overlayHtml = $('<div id="' + this.taskUrl + '" style="width: 100px; height: 80px; border-radius: 10px; ' +
              'border-style: solid; border-color: green; cursor: pointer">' +
              '</div>')
              .css({
                width: shape.width,
                heigth: shape.heigth
              });

            this.overlays.add(this.taskUrl, {
              position: {
                top: 0,
                left: 0
              },
              html: overlayHtml
            });
          }

          this.importDone.emit({
            type: 'success',
            warnings
          });
        },
        (err) => {
          this.importDone.emit({
            type: 'error',
            error: err
          });
        }
      )
    );
  }

  private importDiagram(xml: string): Observable<{warnings: Array<any>}> {
    return from(this.bpmnJS.importXML(xml) as Promise<{warnings: Array<any>}>);
  }
}
